import {Button, ListGroup, Stack} from "react-bootstrap";
import {
    AdminUserAlert, ItemLoading,
    MenuAdd,
    MenuBar,
    MenuClearSelectButton,
    MenuConfirmDeleteButton,
    MenuOrderBy,
    MenuSearchTerm,
    OurClearAlert,
    OurPagination2,
    PageTitle
} from "../../_components";
import React, {useRef} from "react";
import {useFetchJson, useGetJson, useLocalFilter2, useLongPress, useSelect, useTouch} from "../../../hooks";
import {endpoints, formatBytes} from "../../../utils2";
import {useAlert, useAuth} from "../../../context";
import {Link, useParams, useSearchParams} from "react-router-dom";
import {ABOverlayTooltip} from "../../_components/CustomOverlayTooltip";
import {getAudioFile} from "./utils";
import {AvailableSpaceBar} from "./AvailableSpaceBar";
import {WhiteCard} from "../../device/_components/WhiteCard";
import {useBrowserTitle} from "../../../hooks/useBrowserTitle";
import {ResponsiveContent} from "../../ResponsiveNavTabs";
import {OrderStatus} from "../../../utils2/maps";

export function Announcement() {
    useBrowserTitle("Announcement");
    return <ResponsiveContent body={<AnnouncementBody/>}/>
}

function AnnouncementBody() {
    const {authToken} = useAuth()
    const {uid} = useParams()
    const {success} = useAlert()
    const [searchParams] = useSearchParams()


    const [anOrder, loadingAnOrder, errorAnOrder, clearErrorAnOrder] = useGetJson(endpoints.announcement.orderOptions(), authToken?.jwt)
    const orderOptions = anOrder?.data || []

    const search = {query: searchParams.get("query")}
    const [anCount, loadingAnCount, errorAnCount, clearErrorAnCount, setAnnCount] = useGetJson(endpoints.announcement.count(uid, search), authToken?.jwt)
    const announcementCount = anCount?.data || 0

    const [anSize, loadingAnSize, errorAnSize, clearErrorAnSize] = useGetJson(endpoints.announcement.size(uid), authToken?.jwt, null, null, 'GET', [announcementCount])
    const announcementSize = anSize?.data || 0

    const searchL = {
        offset: Number(searchParams.get("index")) * Number(searchParams.get("size")),
        limit: Number(searchParams.get("size")),
        query: searchParams.get("query"),
        order_by: searchParams.get("by")
    }
    const [anList, loadingAnList, errorAnList, clearErrorAnList, setAnnList] = useGetJson(endpoints.announcement.list(uid, searchL), authToken?.jwt)
    const announcementList = anList?.data || []

    const {exec: deleteItem, error: errDeleteItem, clearError: clearErrDeleteItem} = useFetchJson(authToken?.jwt, null, "POST")

    const [subListF, loadingSubListF, errorSubListF, clearErrorSubListF] = useGetJson(endpoints.subscription.filter(uid), authToken?.jwt)
    const subscriptionListFiltered = subListF?.data

    const loading = loadingAnOrder || loadingAnCount || loadingAnList || loadingAnSize || loadingSubListF

    const filteredList = useLocalFilter2(announcementList, ["filename"])

    const [selList, toggleSelectItems, clearSelectItems, isItemSelected] = useSelect(announcementList)

    function handleOnItemsDelete() {
        Promise.all(selList.map(item => new Promise((resolve, reject) =>
            deleteItem(endpoints.announcement.delete(uid, item.id), null, () => resolve(item.id))).catch(err => console.warn(err))))
            .then(ids => {
                success(`${ids.length} announcement(s) deleted!`)
                setAnnList(prev => ({...prev, data: prev.data.filter(item => !ids.includes(item.id))}))
                setAnnCount(prev => ({...prev, data: prev.data - 1}))
                clearSelectItems()
            })
    }


    return <Stack>
        <AdminUserAlert/>
        <OurClearAlert variant="danger" msg={errorAnOrder} onClear={clearErrorAnOrder}/>
        <OurClearAlert variant="danger" msg={errorAnCount} onClear={clearErrorAnCount}/>
        <OurClearAlert variant="danger" msg={errorAnSize} onClear={clearErrorAnSize}/>
        <OurClearAlert variant="danger" msg={errorAnList} onClear={clearErrorAnList}/>
        <OurClearAlert variant="danger" msg={errDeleteItem} onClear={clearErrDeleteItem}/>
        <OurClearAlert variant="danger" msg={errorSubListF} onClear={clearErrorSubListF}/>

        <PageTitle title="Announcement">{announcementCount} announcements.</PageTitle>

        <MenuBar>
            <MenuAdd to={`/backend/announcement/${uid}/add`} icon="plus">Add</MenuAdd>
            <MenuSearchTerm/>
            <MenuOrderBy orderOptions={orderOptions}/>
            <MenuClearSelectButton hide={selList.length === 0} onClick={clearSelectItems}>
                {selList.length} {selList.length === 1 ? "row" : "rows"}
            </MenuClearSelectButton>
            <MenuConfirmDeleteButton hide={selList.length === 0} onSubmit={handleOnItemsDelete}>
                <span>{selList.length} {selList.length === 1 ? "announcement" : "announcements"}</span>
            </MenuConfirmDeleteButton>
        </MenuBar>


        <ItemLoading show={loading}/>

        <WhiteCard>
            <AvailableSpaceBar announcementSize={announcementSize} abSubscription={subscriptionListFiltered?.total_space_in_mb * 1024 * 1024}
                               article_title={subscriptionListFiltered?.article_title} remaining_days={subscriptionListFiltered?.remaining_days}/>
        </WhiteCard>

        {filteredList.length > 0 ?
            <ListGroup variant="flush">
                {filteredList.map(item =>
                    <RenderItem key={item.id}
                                item={item}
                                selected={isItemSelected(item.id)}
                                selectedCount={selList.length}
                                onSelect={toggleSelectItems}
                                to={`/backend/announcement/${uid}/${item.id}`}
                    />
                )}
            </ListGroup>
            :
            <span className="text-center">No announcements.</span>
        }

        <OurPagination2 loading={loading} itemCount={announcementCount}/>
    </Stack>
}

function RenderItem({item, selected, selectedCount, onSelect, to}) {
    const {uid} = useParams()
    const {success, error} = useAlert()
    const {token} = useAuth()
    const touch = useTouch()

    const ref = useRef(null)
    useLongPress(ref, () => onSelect(item.id))

    function handleDownload() {
        getAudioFile(uid, item.id, token, item.filename)
            .then(() => success("Stream downloaded!"))
            .catch((err) => error(err))
    }

    return (
        <div ref={ref} className={`d-flex align-items-center gap-2 p-1 mb-2 rounded ${(selected ? "bg-light-subtle" : "hover-bg-light-subtle")}`}>
            {/*<Stack direction="horizontal" gap="2" className={`mb-1 rounded ${selected && "hover-bg-secondary-subtle"}`}>*/}
            <Stack ref={ref} direction="horizontal" className="flex-grow-1" gap="2">
                <div>
                    <i className="bi bi-megaphone fs-2"/>
                </div>
                <div>
                    <Stack direction="vertical" className="" gap={0}>
                        <Link to={to}
                              className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <span className="text-wrap fw-semibold fs-4">{item.filename}</span>
                        </Link>
                        <div className="text-secondary small">{formatBytes(item.file_size_in_bytes)}</div>
                    </Stack>
                </div>
                <div className="ms-auto">
                    <div className="d-flex align-items-center gap-0">
                        <ABOverlayTooltip tip="Download file"><Button className="link-underline link-underline-opacity-0" variant="link" onClick={handleDownload}>
                            <span className="bi-box-arrow-down"/>
                        </Button></ABOverlayTooltip>
                        {(!touch || selected || selectedCount > 0) &&
                            <Button className="link-underline link-underline-opacity-0" variant="link"
                                    onClick={() => onSelect(item.id)}>
                                <span className={`bi ${selected ? "bi-check-square" : "bi-square"}`}></span>
                            </Button>
                        }
                    </div>
                </div>
            </Stack>

        </div>
    )
}
